<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import TwOverlay from '../components/TwOverlay';
import PricesList from '../components/prices/PricesList';
import PricesControl from '../components/prices/PricesControl';
import PricesListPagination from '../components/prices/PricesListPagination';

export default {
  name: 'Prices',
  components: {
    PricesList,
    TwOverlay,
    PricesControl,
    PricesListPagination,
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      getChannels: 'prices/getChannels',
      clearState: 'prices/clearState',
    }),
  },
  computed: {
    ...mapState({
      filter: state => state.prices.filter,
      products: state => state.prices.products,
    }),
    ...mapGetters({
    }),
  },
  created() {
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.prices.pages.prices'), to: '', disabled: true },
      ],
      title: this.$t('menu.prices.title'),
    });
  },
  mounted() {
    this.getChannels();
  },
  beforeDestroy() {
    this.clearState();
  },
};
</script>

<template>
  <v-flex xs-12 requests>
    <v-progress-circular
      class="prices__loading"
      v-if="filter.loading"
      indeterminate
    />
    <tw-overlay :visible="filter.loading" />
    <prices-control
      :load-new-page="filter.loadNewPage"
      :selected-channel="this.filter.channel"
      :selected-type="this.filter.type"
    />
    <prices-list />
    <prices-list-pagination :pagination-index="this.filter.paginationIndex" />
  </v-flex>
</template>

<style lang="scss">
.prices {
  position: relative;
  min-height: 300px;

  &__loading {
    position: absolute;
    top: 150px;
    left: 50%;
    z-index: 20;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Prices.vue